module.exports = __webpack_public_path__ + "img/cruz.14390fd3.svg";